import { render, staticRenderFns } from "./YachtPage.vue?vue&type=template&id=4a570f4e&scoped=true"
import script from "./YachtPage.vue?vue&type=script&lang=js"
export * from "./YachtPage.vue?vue&type=script&lang=js"
import style0 from "./YachtPage.vue?vue&type=style&index=0&id=4a570f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a570f4e",
  null
  
)

export default component.exports